import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../../shared/shared.module';
import { SignupComponent } from './pages/signup/signup.component';
// import { CompareValidatorModule } from 'angular-compare-validator';

/** Almacena la ruta del componente */
const routes: Route[] = [
  {
    path: '',
    component: SignupComponent,
  },
];
/** Almacena el módulo de rutas */
export const routing = RouterModule.forChild(routes);

@NgModule({
  imports: [
    FormsModule,
    routing,
    SharedModule,
    NgSelectModule,
    // CompareValidatorModule
  ],
  declarations: [SignupComponent],
})
export class SignupModule {}
